import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { setDigiRoot } from './siteSwitch';

const root = ReactDOM.createRoot(document.getElementById('root'));
setDigiRoot(root);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
